import { JobSkillSetType, JobType } from 'common/types/job.types'
import { isLink } from 'common/utils'
import { useHttp } from 'hooks/use-http/useHttp'
import { SetStateAction, useState } from 'react'

export const useJobs = () => {
  const { get, put, post, destroy } = useHttp()
  const [targetJob, setTargetJob] = useState<JobType | null>(null)
  const [isLoading, setIsLoading] = useState(false)

  const isJobExpired = (expiryDate: string) => new Date() > new Date(expiryDate)

  const formatSkillSet = (skillSetData: JobSkillSetType) => (skillSetData?.show ? skillSetData?.skills : '')

  const formatJobStatus = (status: string, expiryDate?: string) => {
    const jobStatuses = {
      active: 'Active',
      disabled: 'Active',
      closed: 'Closed',
      expired: 'Expired'
    }

    return jobStatuses[status?.toLowerCase()]
  }

  const formatBackendJobForClient = (job: JobType) => {
    if (!job) return null

    const { show: showSkillSet } = job?.skillSet

    const skillSet = job?.skillSet?.skills?.toString()
    

    const { frequency, max: maxPay, min: minPay, show: showSalaryRange, currency } = job.salaryRange
    const jobDescriptionArea = job?.jobDescription
    const jobDescription = job?.jobDescription

    return {
      ...job,
      skillSet,
      showSalaryRange,
      jobDescriptionArea:jobDescriptionArea,
      jobDescription,
      currency,
      frequency,
      minPay,
      maxPay,
      showSkillSet
    }
  }

  async function getJobById(id: string) {
    try {
      setIsLoading(true)
      const url = `/job/${id}`
      const options = {}
      const response = await get(url, options)
      const formatedJob = formatBackendJobForClient(response)
      setTargetJob(formatedJob as any)
      setIsLoading(false)
    } catch (error) {
      setIsLoading(false)
    }
  }

  return {
    getJobById,
    targetJob,
    isLoading,
    formatBackendJobForClient,
    isJobExpired,
    formatJobStatus
  } as const
}
